import React from 'react';
import format from 'date-fns/format';

const Footer = props => (
	<footer className="main-footer">
		<div className="pull-right hidden-xs">
			<b>{props.text?.version || 'Version'}</b> {props.version}
		</div>
		<strong>
			&copy; {format(new Date(), 'yyyy')}{' '}
			<a target="_blank" rel="noopener noreferrer" href="http://www.richardson.com">
				Richardson Sales Performance
			</a>
			.
		</strong>
	</footer>
);

export default Footer;
